'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SleepCalendarCtrl', SleepCalendarCtrl);

  SleepCalendarCtrl.$inject = ['onboardingRouter', 'userSvc', 'sleepCheckInSvc', 'focus'];

  function SleepCalendarCtrl(onboardingRouter, userSvc, sleepCheckInSvc, focus) {
    var vm = this;
    var SLEEP_DIARY_ON_SETTING = 'sleep_diary_enabled:true';
    var SLEEP_DIARY_OFF_SETTING = 'sleep_diary_enabled:false';
    var EMAIL_REMINDER_SETTING = 'sleep_diary_reminder:email';
    vm.$onInit = function () {
      focus.byId('loginSleepHeading', 500);
    };
    vm.skipCheckin = _navigate;
    vm.disableDiary = _disableDiary;
    vm.onUpdateDay = _onUpdateDay;

    function _navigate(checkIn) {
      if (!checkIn) {
        var _checkIn = {
          checkInStatus: 'SKIP'
        };
        sleepCheckInSvc.saveCheckIn(_checkIn).then(function (resp) {
          onboardingRouter.goToNextStep({ cid: resp }, {
            name: 'onboarding.mood.overlay'
          });
        });
      } else {
        onboardingRouter.goToNextStep({}, {
          name: 'onboarding.mood.overlay'
        });
      }
    }

    function _onUpdateDay(day) {
      onboardingRouter.goToState('^.entry', {
        day: day
      });
    }

    function _disableDiary() {
      var saveTags = [];
      var removeTags = [];

      saveTags.push(SLEEP_DIARY_OFF_SETTING);
      removeTags.push(SLEEP_DIARY_ON_SETTING);
      removeTags.push(EMAIL_REMINDER_SETTING);

      userSvc.saveTagPreferences(saveTags, removeTags).then(_navigate);
    }
  }
})();